<template>
    <div class="icon-Chevron-Right"></div>
</template>